import { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';

type InfoSectionProps = {
  id: string;
  title: string;
  children: ReactNode;
};

export const InfoSection = ({ id, title, children }: InfoSectionProps) => (
  <Stack id={id} data-section pt={{ xs: 8, md: 0 }} spacing={3}>
    <Typography variant="h4" className="large semi-bold" sx={{ maxWidth: 671 }}>
      {title}
    </Typography>
    {children}
  </Stack>
);
